import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PaginationSection from "components/QuanTriHeThong/QuanLyLog/PaginationSection";
import GiaoDichChoDuyetTable from "./GiaoDichChoDuyetTable";
import React, { useEffect, useState, useCallback } from "react";
import UserApi from "service/userApi";
import "react-dropdown/style.css";
import { formatDayMonth } from "utils/formatDate";
import GiaoDichChoDuyetApi from "service/GiaoDichChoDuyetApi";
import DanhSachQuyKhacApi from "service/DanhSachQuyKhacApi";
import { pushNotification } from "utils/notifications";
import DeleteAccessModel from "./DeleteAccessModel";

const GiaoDichChoDuyet = () => {
    const [listUserName, setListUserName] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dataResponse, setdataResponse] = useState([]);
    const [modalType, setModalType] = useState(null);
    const closeModal = () => setModalType(null);

    const [ThuChiId, setID] = useState(0);
    const [ShowModel, setShowModel] = useState(null)
    const [TypeModel, setTypeModel] = useState("")

    const [hasPermission, setHasPermission] = useState(null);

    const fetchPermission = async () => {
        try {
            const res = await UserApi.getAllQuyen();
            const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
            setHasPermission(roles.includes("giaodichchoduyet"));
        } catch (err) {
            console.error("Lỗi load quyền:", err);
            setHasPermission(false);
        }
    };
    const loadDanhSachUserName = useCallback(async () => {
        try {

            const res = await UserApi.getAllUserName();

            setListUserName(res.data || []);
        } catch (error) {
            console.error("Lỗi load danh sách user name:", error);
        }
    }, []);

    const [dataSearch, setDataSearch] = useState({
        sCode: "",
        sFromDate: null,
        sToDate: null,
        sUserName: "",
        pageIndex: 1,
        pageSize: 20,
    });


    const LoadDanhSachGiaoDichChoDuyet = useCallback(async (searchData,page) => {
        try {
            setLoading(true);
            const payload = {
                ...searchData,
                sFromDate: searchData.sFromDate
                    ? formatDayMonth(searchData.sFromDate)
                    : undefined,
                sToDate: searchData.sToDate
                    ? formatDayMonth(searchData.sToDate)
                    : undefined,
                pageIndex: page,
            };
            const res = await GiaoDichChoDuyetApi.list(payload);
            // console.log("Data response: ", res.data);
            const listData = res.data || [];

            setdataResponse(listData);

            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        } catch (error) {
            console.error("Lỗi load danh sách giao dịch chờ duyệt:", error);
        } finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        document.title = "Giao dịch chờ duyệt | Phần mềm quản lý cầm đồ Morman";
        fetchPermission();
        loadDanhSachUserName();
    }, []);

    useEffect(() => {
        if (hasPermission) {
            LoadDanhSachGiaoDichChoDuyet(dataSearch,1);
        }
    }, [hasPermission]);

    const onChangeData = (field) => (event) => {
        const value = event?.target?.value ?? "";
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const onChangeDate = (field) => (value) => {
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };
    const handlePageChange = (pageNumber) => {
        LoadDanhSachGiaoDichChoDuyet(dataSearch,pageNumber);
    };

    const onSearch = () => {
        LoadDanhSachGiaoDichChoDuyet(dataSearch,1);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            LoadDanhSachGiaoDichChoDuyet(dataSearch,1);
        }
    };


    const btnDeleteClick = (ThuChiId) => {
        setTypeModel("Delete");
        setID(ThuChiId);
        setShowModel(true);
    }
    const btnAccessClick = (ThuChiId) => {
        setTypeModel("Access");
        setID(ThuChiId);
        setShowModel(true);
    }
    
    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div
                            className="custom-table-cell text-center red"
                            style={{ width: "100%" }}
                        >
                            Bạn không có quyền truy cập trang này!
                        </div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }
    return (<>
        <LayoutV2>
            <div id="form-repeater">
                <div className="sticky-moman-bh">
                    <div className="col-12">
                        <div className="camdo-home">
                            <div className="breadcrumb-new">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 title-cd">
                                        <div className="media-home align-center-home">
                                            <div className="row header">
                                                <img
                                                    src="/app-assets/images/icon-hop-dong-cho-duyet.png"
                                                    alt="logo"
                                                />
                                                <h1 className="text-info-home">Giao dịch chờ duyệt</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="card border-light mb-3 show-table-main card-v2"
                                style={{}}
                            >
                                <div className="card-body card-body-v2">
                                    <SearchForm
                                        listUserName={listUserName}
                                        dataSearch={dataSearch}
                                        onChangeData={onChangeData}
                                        onChangeDate={onChangeDate}
                                        onSearch={onSearch}
                                        handleKeyDown={handleKeyDown}
                                    />
                                </div>
                            </div>
                            {loading && (<>
                                <div className="loader loader-default is-active"></div>
                            </>)}
                            {!loading && (<>
                                <div
                                    className="card border-light mb-3 card-v2"
                                    style={{ marginTop: "-35px" }}
                                >
                                    <div className="card-body card-body-v2" style={{ userSelect: "text" }}>

                                        <GiaoDichChoDuyetTable
                                            list={dataResponse}
                                            pageIndex={dataSearch.pageIndex}
                                            pageSize={dataSearch.pageSize}
                                            btnAccessClick={btnAccessClick}
                                            btnDeleteClick={btnDeleteClick}
                                        />
                                    </div>
                                    <div
                                        className="card border-light mb-3 card-v2"
                                        style={{
                                            marginLeft: "15px",
                                            marginRight: "15px",
                                            marginTop: "15px",
                                        }}
                                    >
                                        <div
                                            className="card-body card-body-v2"
                                            style={{ display: dataResponse.iTotal === 0 ? "none" : "block" }}
                                        >
                                            <PaginationSection
                                                iTotal={dataResponse.iTotal}
                                                dataSearch={dataSearch}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>)}
                        </div>
                    </div>
                </div>
                {ShowModel &&
                    (<DeleteAccessModel
                        ThuChiId={ThuChiId}
                        onClose={() => setShowModel(false)}
                        LoadDanhSachGiaoDichChoDuyet={()=>LoadDanhSachGiaoDichChoDuyet(dataSearch,1)}
                        ModelTitle={TypeModel}
                    />)
                }
            </div>
        </LayoutV2>
    </>)

}

export default GiaoDichChoDuyet;